<template>
		<span class="SuggestionSectionTitle" v-if="hasSuggestions">{{title}}</span>
		<div class="SuggestionSection" ref="suggestionsRef">
			<SelectionSuggestion :selectionKey="disciplineFilterKey"/>
		</div>
</template>

<script lang="ts" src="./DisciplineSuggestions.ts"></script>
<style lang="scss" src="./DisciplineSuggestions.scss" scoped></style>
